import React, { useMemo } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { useMediaQuery, CssBaseline } from '@mui/material'
import Auth from './pages/auth/auth'
import { getTheme } from './theme/theme'

const App: React.FC = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const theme = useMemo(() => getTheme(prefersDarkMode ? 'dark' : 'light'), [prefersDarkMode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Auth />
    </ThemeProvider>
  )
}

export default App 